import React from 'react';
import {SafeAreaView, ScrollView, StyleSheet, Text, View} from 'react-native';
import cstyles from '../styles/Styles';
import UserRegistrationComponent from './UserRegistrationComponent';
import Footer from "./Footer";

const UserRegistrationScreen = ({navigation, props, route}) => {
  return (
    <SafeAreaView style={cstyles.container}>
        <ScrollView style={lstyles.scrollView}>
            <Text style={lstyles.userRegHeading}>
                User Registration
            </Text>
            <View style={lstyles.userRegistrationContainerInSelf}>
            <UserRegistrationComponent />
            </View>
        </ScrollView>
        <Footer />
    </SafeAreaView>
  );
};

// Styles local to this component
const lstyles = StyleSheet.create({
    scrollView: {
        maxWidth: 980,
        minWidth: 360,
        minHeight: 700,
    },
    userRegistrationContainerInSelf: {
        marginTop: 50,
        marginBottom: 50,
    },
    userRegHeading: {
        color: '#21619A',
        fontSize: 60,
        margin: 5,
        fontWeight: 'bold',
    },
});

export default UserRegistrationScreen;
